import type { FC } from "react";

import CoreHeaderCounterInline from "./CoreHeaderCounterInline";
import createComponentPreset from "../../../../../../fabrics/createComponentPreset";
import { DEFAULT_QUANTITY } from "../../../../../Counter/Counter";

import type { HeaderCounterInlineProps } from "./CoreHeaderCounterInline";

export const createCounterInlineFabric = (
    displayName: string,
    testId: string,
) =>
    createComponentPreset<FC<HeaderCounterInlineProps>>(
        displayName,
        CoreHeaderCounterInline,
        {
            "data-tsid": testId,
            quantity: DEFAULT_QUANTITY,
        },
    );

export default createCounterInlineFabric;
